const usabillaScriptId = () => {
    return window.env.REACT_APP_USABILLA_SCRIPT_ID || 'e5ff5dc56958';
};

const Usabilla = () => {
    window.usabilla.load("w.usabilla.com", usabillaScriptId());
};

export default Usabilla;
